"use client";

import * as React from "react";

import { AssertiveA11yComponentContainer } from "./styled";
import type { AssertiveA11yComponentProps } from "./types";

export const AssertiveA11yComponent = (
  props: AssertiveA11yComponentProps,
): React.ReactElement => {
  const { announcementText, assertType = "assertive" } = props;

  return (
    <AssertiveA11yComponentContainer aria-live={assertType}>
      {announcementText}
    </AssertiveA11yComponentContainer>
  );
};
